import type { IMe } from '@platform/core/types';

/**
 * Чи може користувач сортувати, фільтрувати й групувати записи простору `ws` за полями з персональними даними (сервер:
 * AccessPolicy.CanAggregatePii — лише Owner/Admin і не в режимі лише перегляду; іншим такі запити — 400/403): роль у просторі, а для
 * адміністратора платформи поза членством — Admin (EffectiveRole); сесія спостерігача — ніколи. Чиста функція.
 */
export function canQueryPii(me: Pick<IMe, 'globalRole' | 'workspaces'> | undefined, ws: string, observer: boolean): boolean {
  if (!me || observer) return false;
  const role = me.workspaces.find((w) => w.id === ws)?.myRole ?? (me.globalRole === 'Platform admin' ? 'Admin' : undefined);
  return role === 'Owner' || role === 'Admin';
}
